// extracted by mini-css-extract-plugin
export default {"container":"style_container__l+xWI","page":"style_page__5yMqt","error":"style_error__TLsYl"};